import React, { useCallback, useState } from 'react';
import {
  Select, MenuItem, Grid, Box,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import StyledInput from '../../actions/StyledInput';
import StudioToolTip from '../../actions/StudioToolTip';
import { StudioControlStyles } from '../../styles';
import {
  setDropdownSelectMode, setAudioId,
} from '../../../../store/modules/studio/actions';
import {
  selectCameraRecording,
  selectCountdownCamera,
  selectAudioId,
} from '../../../../store/modules/studio/selectors';


type Props = {
  audioDevices: MediaDeviceInfo[];
}

const SelectAudioDeviceAction = ({audioDevices}: Props) => {
  const classes = StudioControlStyles();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const audioId = useSelector(selectAudioId);
  const isRecording = useSelector(selectCameraRecording);
  const isCountdown = useSelector(selectCountdownCamera);
  /* eslint-disable react-hooks/exhaustive-deps */

  const onChange = useCallback((event: React.ChangeEvent<{value: unknown}>) => {
    dispatch(setAudioId(event.target.value as string));
  }, [dispatch, audioId]);

  const openHandler = useCallback(() => {
    setOpen(true);
    dispatch(setDropdownSelectMode(true));
  }, [dispatch, setOpen]);

  const closeHandler = useCallback(() => {
    setOpen(false);
    dispatch(setDropdownSelectMode(false));
  }, [dispatch, setOpen]);

  return (
    <Grid item container className={classes.audioSelectContainer}>
      <StudioToolTip title="Select which audio will be used">
        <Box style={{ width: '100%' }}>
          <p className={classes.label}>Audio</p>
          <Select
            open={open}
            data-tip="Change camera"
            variant="outlined"
            className={clsx(classes.selection, classes.selectAutoWidth)}
            input={<StyledInput />}
            value={audioId}
            onChange={onChange}
            MenuProps={{
              style: {
                zIndex: 2147483101,
              },
            }}
            data-intercom-target="Dropdown: Audio"
            onOpen={openHandler}
            onClose={closeHandler}
            disabled={isRecording || !audioDevices.length || isCountdown}
          >
            {audioDevices.length?
              audioDevices.map((item) => (
                <MenuItem key={item.deviceId} value={item.deviceId}>
                  {item.label}
                </MenuItem>
              )):
              <MenuItem  value={''}/>
            }
          </Select>
        </Box>
      </StudioToolTip>
    </Grid>
  );
};

export default SelectAudioDeviceAction;
